'use strict';

import React, { Component } from 'react';
import ValidationOverlay from './validationOverlay.jsx';
import PopUp from '../../../commonModules/interface/PopUp.jsx';
import { Box, Grid } from '@material-ui/core';
import InputText from '../../../commonModules/interface/form-input-inline.jsx';
import { Alert } from '@material-ui/lab';


class NewSim extends Component{

	state ={
		//Initiate Default User
		msg: "",
		popupStateValidation: false,
		Number: "",
		Pin: "",
		Operator:"",
		APN: "",
		CarteSimId: "",
		Puk: "",
		errmsg: "",
		url: "",
	}
    onValidation= async (e) => {
        e.preventDefault();
        //Test if ok
        if (this.state.Number === ''){
			this.setState({errmsg: "Numero can not be empty"});
			return;
        }
        if (this.state.Operator === ''){
			this.setState({errmsg: "Operator can not be empty"});
			return;
        }
        if (this.state.APN === ''){
			this.setState({errmsg: "APN can not be empty"});
			return;
        }
        if (this.state.Pin === ''){
			this.setState({errmsg: "Pin can not be empty"});
			return;
        }
        var msg = "Record SIM  numero : "+this.state.Number + ", pin: "+this.state.Pin+" , Opérateur :"+this.state.Operator+ ", apn :"+this.state.APN;
        var url = "sim/new?num=" + this.state.Number + "&pin=" + this.state.Pin + "&operator=" + this.state.Operator + "&apn=" + this.state.APN+ "&puk=" + this.state.Puk+ "&id=" + this.state.CarteSimId;
        //Active Pop up Security
        this.setState({popupStateValidation: true,msg:msg,url:url});
    }

	
    onCancelation= async () => {
        this.setState({
            popupStateValidation:false,
        })
    }
    onValidationSucceed= async () => {
		this.setState({     
			msg: "",
			popupState: false,
			popupStateValidation: false,
			Number: "",
			Pin: "",
			Operator:"",
			APN: "",
			errmsg:"",
			url:"",
		})
		this.props.onCloseOverlay();
    }
    onChangeNumber= async (e) => {
      e.preventDefault();
      var num = e.target.value;
      this.setState({Number: num});
    }
    onChangePin= async (e) => {
        e.preventDefault();
        var pin = e.target.value;
        this.setState({Pin: pin});
    }
    onChangeOperator= async (e) => {
        e.preventDefault();
        var operator = e.target.value;
        this.setState({Operator: operator});
    }
    onChangeAPN= async (e) => {
        e.preventDefault();
        var apn = e.target.value;
        this.setState({APN: apn});
    }
    onChangeIdCarteSim= async (e) => {
		e.preventDefault();
		var carteSimId = e.target.value;
		this.setState({CarteSimId: carteSimId});
    }
    onChangePuk= async (e) => {
		e.preventDefault();
		var puk = e.target.value;
		this.setState({Puk: puk});
    }
   
    render() {
        return (			
			<PopUp 
				title="Nouvelle SIM"
				close={this.props.onCloseOverlay}
				submitAction={this.onValidation}
			>
				{this.state.errmsg &&
					<Alert severity="error">
						{this.state.errmsg}
					</Alert>
				}
				<Grid container>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Phone Number"
							value={this.state.Number} 
							onChange={this.onChangeNumber}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Pin Number"
							value={this.state.Pin} 
							onChange={this.onChangePin}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Puk Number"
							value={this.state.Puk} 
							onChange={this.onChangePuk}
						/>
						
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Id Carte"
							value={this.state.IdCarteSim} 
							onChange={this.onChangeIdCarteSim}
						/>
						
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="Operator"
							value={this.state.Operator} 
							onChange={this.onChangeOperator}
						/>
					</Grid>
					<Grid item xs={12} sm={6}>
						<InputText
							label="APN"
							value={this.state.APN} 
							onChange={this.onChangeAPN}
						/>
					</Grid>
				</Grid>
				{this.state.popupStateValidation &&
					<ValidationOverlay
						msg={this.state.msg}
						// popupStateButton={this.state.popupStateValidation}
						url={this.state.url}
						onValidation={this.onValidationSucceed}
						onCancelation={this.onCancelation}
					/>
				}
			</PopUp>
        );
    }
};
export default NewSim